export default "__VITE_ASSET__2aa343fc__"